export const LocationsSavingBehaviourType = {
  Always: 0,
  Ask: 1,
} as const;
export type LocationsSavingBehaviourType =
  (typeof LocationsSavingBehaviourType)[keyof typeof LocationsSavingBehaviourType];
